import React from 'react';

interface LoginErrorProps {
  onReturn?: () => void;
  error?: {
    message?: string;
    displayToUser?: boolean;
    retryable?: boolean;
    clearCache?: boolean;
  };
  retryHandler?: () => void;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function LoginError({ error, onReturn, retryHandler }: LoginErrorProps) {
  if (error && error.message) {
    console.error('Failed to complete SSO Login: ', error.message);
  }

  return (
    <div className="login-loading-container">
      <div className="login-loading-content">
        <div className="login-loading-main-text">Sorry!</div>
        <div className="login-loading-sub-text">
          {
            error && error.message && error.displayToUser
              ? (
                <div>
                  We could not log you in due to &quot;{error.message}&quot;, {error.retryable ? (<>please wait, automatically retrying again in a moment...</>) : (<>please try again later or reach out to your local workplace experience team!</>)}
                </div>
              )
              : (
                <div>
                  Something went wrong and we could not log you in. {error && error.retryable ? (<>please wait, automatically retrying again in a moment...</>) : (<>please try again {error?.clearCache ? ' after clearing your browser cache or try in Incognito / Private browsing mode. If this issue persists, please ' : ' later or '} reach out to your local workplace experience team!</>)}
                </div>
              )
          }
        </div>

      </div>
    </div >
  );
}

export default LoginError;
